// extracted by mini-css-extract-plugin
export var center = "_1w-2";
export var clickableRow = "_1w-5";
export var expandedRow = "_1w-7";
export var hoverable = "_1w-4";
export var left = "_1w-1";
export var right = "_1w-3";
export var row = "_1w-0";
export var selectedRow = "_1w-6";
export var summaryRow = "_1w-8";